export const ru = {
    'cpa-sign': 'Посчитано с учетом сохранения CPA',
    'many-days-clicks-title': 'Прогноз кликов за {value} дней',
    'many-days-cost-title': 'Прогноз расхода за {value} дней',
    'many-days-ctr-title': 'Прогноз конверсий за {value} дней',
    'one-day-clicks-title': 'Прогноз кликов за {value} день',
    'one-day-cost-title': 'Прогноз расхода за {value} день',
    'one-day-ctr-title': 'Прогноз конверсий за {value} день',
    'roi-sign': 'Посчитано с учетом сохранения ROI',
    'some-days-clicks-title': 'Прогноз кликов за {value} дня',
    'some-days-cost-title': 'Прогноз расхода за {value} дня',
    'some-days-ctr-title': 'Прогноз конверсий за {value} дня'
};
